import { useCallback, useState } from 'react';
import { isPrint } from './copy';
import { toast } from 'react-toastify';
function isClientError(status) {
    return status > 399 && status < 500;
}

function showErrorFromApiResponse(errorsInput) {
    const errors = errorsInput || {};
    Object.values(errors).forEach(error => {
        toast.error(error.join(' '));
    });
}
export const QueryForm = (action, options = {}) => {
    const [loading, setLoading] = useState(false);
    const submit = useCallback(async (data, onSuccess = () => { }, onError = () => { }) => {
        const {
            unHundleedErrorMessage = 'Something Went Wrong',
        } = options;
        try {
            setLoading(true)
            const { data: responseData } = await action(data);
            if (responseData && responseData.success) {
                if (isPrint(responseData.success)) {
                    toast.success(responseData.success);
                }
            }
            onSuccess(responseData);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            if (err.response && isClientError(err.response.status)) {
                onError(err.response);
                const { response: { data: responseData } = {} } = err;
                if (typeof responseData === 'object' && responseData.errors) {
                    return showErrorFromApiResponse(responseData.errors);
                } else {
                    if (isPrint(responseData.error)) {
                        toast.error(responseData.error);
                    }
                    if (isPrint(responseData.email)) {
                        toast.error(responseData.email);
                    }
                }
                return toast.error(responseData);
            }
            if (err.response && !isClientError(err.response.status)) {
                return toast.error(unHundleedErrorMessage);
            }
        }
    }, [action, setLoading, options])
    return [submit, { loading }];

}
